import { instance } from '../../api/setup'
import { updatePermissions } from '../../services/abilityService'
// initial state
const state = {
  status: 'sds',
  token: localStorage.getItem('token') || '',
  user: ''
}

// getters
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status
}

// actions
const actions = {
  login ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      instance({ url: '/logins', data: data, method: 'POST' }).then(resp => {
        const token = resp.data.token
        const user = resp.data.user
        const permissions = resp.data.permissions
        updatePermissions(permissions)
        let admin
        if (resp.data.admin) {
          admin = JSON.stringify({ status: true })
        } else {
          admin = JSON.stringify({ status: false })
        }
        localStorage.setItem('token', token)
        localStorage.setItem('user', user)
        localStorage.setItem('admin', admin)
        localStorage.setItem('permissions', JSON.stringify(permissions))
        instance.defaults.headers.common.Authorization = token
        commit('auth_success', token, user)
        resolve(resp)
      }).catch(err => {
        commit('auth_error')
        localStorage.removeItem('token')
        reject(err)
      })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      delete instance.defaults.headers.common.Authorization
      resolve()
    })
  }
}

// mutations
const mutations = {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, token, user) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
